import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  districts: [],
  isLoading: false
})

const getters = {
  districts: (state) => state.districts,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_DISTRICTS(state, payload) {
    state.districts = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchDistricts({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data
        commit('SET_DISTRICTS', message.data)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createDistrict({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/district`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/districts')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteDistrict(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/district/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchDistrict(_context, { id, vm }) {
    vm.mLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/district/${id}`)
      .then((res) => {
        const message = res.data.data
        vm.editForm.nameEn = message.name_en
        vm.editForm.nameRu = message.name_ru
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.mLoading = false
      })
  },
  updateDistrict(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.mLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/district/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editDistrictModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.mLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
